import { BLOCK_REGISTRY } from './registry';
import type { BlockRendererProps } from './BlockRenderer.types';

// Single switch point: looks up the component from BLOCK_REGISTRY by
// `output.type`. Unknown variants render nothing (graceful degradation when
// the backend ships a type the frontend doesn't recognise yet).
export const BlockRenderer = ({ output }: BlockRendererProps) => {
  const Component = BLOCK_REGISTRY[output.type];
  if (!Component) return null;
  return <Component data={output.data as never} />;
};
